module.exports = __webpack_public_path__ + "static/media/down_arrow.23475165.png";